"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var FormComponent = /*#__PURE__*/function (_Component) {
  _inherits(FormComponent, _Component);

  function FormComponent() {
    _classCallCheck(this, FormComponent);

    return _possibleConstructorReturn(this, _getPrototypeOf(FormComponent).apply(this, arguments));
  }

  _createClass(FormComponent, [{
    key: "printChildren",
    value: function printChildren() {
      var elements = [];
      var state = this.props.formHandler.state;
      this.props.children.forEach(function (child, key) {
        var fieldError = null;

        if (child.props && child.props.name) {
          for (var i = 0; i < state.errors.length; i++) {
            var error = state.errors[i];

            if (child.props.name === error.field) {
              fieldError = error;
              break;
            }
          }
        }

        if (fieldError) {
          elements.push(_react["default"].cloneElement(child, {
            error: fieldError,
            key: 'input-field-' + fieldError.field
          }));
        } else {
          elements.push(child);
        }
      });
      return elements;
    }
    /**
     * Render template
     *
     * @returns {XML}
     */

  }, {
    key: "render",
    value: function render() {
      // let submissionStatus = this.props.formHandler.getSubmissionStatus();
      var formClass = this.props.formHandler.getFormClass(); // let loadingComponent = this.props.formHandler.getLoadingComponent();

      var children = this.printChildren();
      return _react["default"].createElement("div", {
        className: "login-form relative-position"
      }, _react["default"].createElement("form", {
        className: formClass,
        id: this.props.id,
        method: "",
        action: "",
        onSubmit: this.props.formHandler.handleSubmit.bind(this.props.formHandler)
      }, children)); // return (
      //     <div className="register-form relative-position">
      //         {loadingComponent}
      //         <form className={formClass} id="registerForm" method="" action="" onSubmit={this.props.formHandler.handleSubmit.bind(this.props.formHandler)}>
      //             {children}
      //         </form>
      //     </div>
      // );
    }
  }]);

  return FormComponent;
}(_react.Component);

exports["default"] = FormComponent;